import { render, staticRenderFns } from "./userinfo.vue?vue&type=template&id=4f9c9012&scoped=true&"
import script from "./userinfo.vue?vue&type=script&lang=js&"
export * from "./userinfo.vue?vue&type=script&lang=js&"
import style0 from "./userinfo.vue?vue&type=style&index=0&id=4f9c9012&lang=less&scoped=true&"
import style1 from "./userinfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c9012",
  null
  
)

export default component.exports